import { render } from "./AudienceBans.vue?vue&type=template&id=44efef53"
import script from "./AudienceBans.vue?vue&type=script&setup=true&lang=js"
export * from "./AudienceBans.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/audience/AudienceBans.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44efef53"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44efef53', __exports__)) {
    api.reload('44efef53', __exports__)
  }
  
  module.hot.accept("./AudienceBans.vue?vue&type=template&id=44efef53", () => {
    api.rerender('44efef53', render)
  })

}


export default __exports__